document.addEventListener('DOMContentLoaded', function () {

  /* ================================================================
     Toast notifications (used for cart/network error + success states)
     ================================================================ */
  var toastRegion = document.createElement('div');
  toastRegion.className = 'toast-region';
  toastRegion.setAttribute('role', 'status');
  toastRegion.setAttribute('aria-live', 'polite');
  document.body.appendChild(toastRegion);

  function showToast(message, type) {
    var el = document.createElement('div');
    el.className = 'toast' + (type ? ' toast-' + type : '');
    el.textContent = message;
    toastRegion.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.remove(); }, 300);
    }, 3500);
  }
  window.themeToast = showToast;

  /* ================================================================
     Focus trap helper for modal-like panels (cart drawer, exit popup)
     ================================================================ */
  function trapFocus(container, previouslyFocused) {
    var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    function handleKeydown(e) {
      if (e.key !== 'Tab') return;
      var focusable = Array.prototype.filter.call(
        container.querySelectorAll(focusableSelector),
        function (el) { return el.offsetParent !== null; }
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
    container.addEventListener('keydown', handleKeydown);
    var firstFocusable = container.querySelector(focusableSelector);
    if (firstFocusable) setTimeout(function () { firstFocusable.focus(); }, 50);
    return function release() {
      container.removeEventListener('keydown', handleKeydown);
      if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
        previouslyFocused.focus();
      }
    };
  }

  /* ================================================================
     Password visibility toggle + strength meter
     ================================================================ */
  document.querySelectorAll('[data-password-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrapper = btn.closest('.password-input');
      var input = wrapper ? wrapper.querySelector('[data-password-input]') : null;
      if (!input) return;
      var showing = input.type === 'text';
      input.type = showing ? 'password' : 'text';
      btn.classList.toggle('is-active', !showing);
      btn.setAttribute('aria-pressed', showing ? 'false' : 'true');
      btn.setAttribute('aria-label', showing ? 'Show password' : 'Hide password');
    });
  });

  function passwordStrength(value) {
    var score = 0;
    if (value.length >= 8) score++;
    if (value.length >= 12) score++;
    if (/[A-Z]/.test(value) && /[a-z]/.test(value)) score++;
    if (/[0-9]/.test(value)) score++;
    if (/[^A-Za-z0-9]/.test(value)) score++;
    return Math.min(score, 4);
  }
  var strengthLabels = ['Too short', 'Weak', 'Fair', 'Good', 'Strong'];
  var strengthColors = ['#B3392C', '#B3392C', '#D98A2B', '#3A9BD9', '#2E9E6F'];

  document.querySelectorAll('[data-password-strength]').forEach(function (meter) {
    var field = meter.closest('.field--password');
    var input = field ? field.querySelector('[data-password-input]') : null;
    var fill = meter.querySelector('[data-password-strength-fill]');
    var label = meter.querySelector('[data-password-strength-label]');
    if (!input) return;
    input.addEventListener('input', function () {
      if (!input.value) {
        if (fill) fill.style.width = '0%';
        if (label) label.textContent = '';
        return;
      }
      var score = passwordStrength(input.value);
      if (fill) { fill.style.width = (score / 4 * 100) + '%'; fill.style.background = strengthColors[score]; }
      if (label) label.textContent = strengthLabels[score];
    });
  });

  /* Password confirmation matching (register / reset / activate forms) */
  document.querySelectorAll('[data-password-confirm-of]').forEach(function (confirmInput) {
    var primary = document.getElementById(confirmInput.dataset.passwordConfirmOf);
    var form = confirmInput.closest('form');
    var errorEl = form ? form.querySelector('[data-password-match-error]') : null;
    var submitBtn = form ? form.querySelector('button[type="submit"]') : null;
    if (!primary) return;
    function check() {
      var mismatch = confirmInput.value.length > 0 && primary.value !== confirmInput.value;
      if (errorEl) errorEl.style.display = mismatch ? 'block' : 'none';
      confirmInput.setAttribute('aria-invalid', mismatch ? 'true' : 'false');
      if (submitBtn) submitBtn.disabled = mismatch;
    }
    primary.addEventListener('input', check);
    confirmInput.addEventListener('input', check);
  });

  /* ================================================================
     Login: "Forgot your password?" collapsible panel (unobtrusive)
     ================================================================ */
  var recoverToggle = document.querySelector('[data-recover-toggle]');
  var recoverPanel = document.querySelector('[data-recover-panel]');
  if (recoverToggle && recoverPanel) {
    recoverToggle.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = recoverPanel.classList.toggle('is-open');
      recoverToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) {
        var firstInput = recoverPanel.querySelector('input');
        if (firstInput) setTimeout(function () { firstInput.focus(); }, 50);
      }
    });
  }

  /* ================================================================
     Addresses: add/edit form toggles (unobtrusive)
     ================================================================ */
  document.querySelectorAll('[data-toggle-target]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById(btn.dataset.toggleTarget);
      if (!target) return;
      var isOpen = target.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) {
        var firstInput = target.querySelector('input, select');
        if (firstInput) setTimeout(function () { firstInput.focus(); }, 50);
      }
    });
  });

  /* ================================================================
     Delete-address confirmation (unobtrusive, replaces inline onclick)
     ================================================================ */
  document.querySelectorAll('[data-confirm-message]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (!window.confirm(btn.dataset.confirmMessage)) {
        e.preventDefault();
      }
    });
  });

  /* Static cart page: "Remove" sets qty to 0 and submits the update form */
  document.querySelectorAll('[data-cart-page-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById(btn.dataset.lineInput);
      var form = btn.closest('form');
      if (!input || !form) return;
      input.value = 0;
      form.submit();
    });
  });


  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* ================================================================
     Header search dropdown
     ================================================================ */
  var searchPanel = document.querySelector('[data-search-panel]');
  var searchInput = document.querySelector('[data-search-input]');
  var searchResults = document.querySelector('[data-search-results]');
  var searchToggles = document.querySelectorAll('[data-search-toggle]');
  var searchClose = document.querySelector('[data-search-close]');
  var searchTimer;

  function openSearch(){
    if (!searchPanel) return;
    searchPanel.classList.add('is-open');
    searchToggles.forEach(function(btn){ btn.setAttribute('aria-expanded', 'true'); });
    if (searchInput) setTimeout(function(){ searchInput.focus(); }, 150);
  }
  function closeSearch(){
    if (!searchPanel) return;
    searchPanel.classList.remove('is-open');
    searchToggles.forEach(function(btn){ btn.setAttribute('aria-expanded', 'false'); });
  }

  searchToggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (searchPanel.classList.contains('is-open')) { closeSearch(); } else { openSearch(); }
    });
  });
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  if (searchInput && searchResults && window.fetch) {
    searchInput.addEventListener('input', function () {
      var term = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (term.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              searchResults.innerHTML = '<div class="header-search__empty">No products found for "' + term.replace(/</g,'') + '"</div>';
              return;
            }
            searchResults.innerHTML = products.map(function (p) {
              var img = p.image || '';
              return '<a class="header-search__result" href="' + p.url + '">' +
                (img ? '<img src="' + img + '" alt="" width="48" height="48">' : '') +
                '<span><span class="header-search__result-title">' + p.title + '</span><br>' +
                '<span class="header-search__result-price">' + p.price + '</span></span></a>';
            }).join('');
          })
          .catch(function () {
            searchResults.innerHTML = '<div class="header-search__empty">Search is unavailable right now — please try again.</div>';
          });
      }, 250);
    });
  }

  /* ================================================================
     Product gallery thumbnails
     ================================================================ */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb, i) {
      thumb.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + thumbs.length);
      thumb.setAttribute('aria-current', thumb.classList.contains('active') ? 'true' : 'false');
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); t.setAttribute('aria-current', 'false'); });
        thumb.classList.add('active');
        thumb.setAttribute('aria-current', 'true');
        if (main) main.src = thumb.dataset.fullSrc || thumb.querySelector('img').src;
      });
    });
  });

  /* ================================================================
     Product tabs
     ================================================================ */
  document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
    var buttons = wrap.querySelectorAll('[data-tab-button]');
    var panels = wrap.querySelectorAll('[data-tab-panel]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('active'); b.setAttribute('aria-selected', 'false'); });
        panels.forEach(function (p) { p.style.display = 'none'; });
        btn.classList.add('active');
        btn.setAttribute('aria-selected', 'true');
        var target = wrap.querySelector('[data-tab-panel="' + btn.dataset.tabButton + '"]');
        if (target) target.style.display = 'block';
      });
    });
  });

  /* ================================================================
     Quantity selector (product page / cart page)
     Cart drawer lines are handled separately via AJAX further down.
     ================================================================ */
  document.querySelectorAll('[data-qty-selector]').forEach(function (sel) {
    if (sel.closest('[data-cart-items]')) return;
    var input = sel.querySelector('input');
    function clamp(val) {
      var n = parseInt(val, 10);
      if (isNaN(n) || n < 1) n = 1;
      return n;
    }
    sel.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        input.value = clamp((parseInt(input.value, 10) || 1) - 1);
        input.dispatchEvent(new Event('change'));
      });
    });
    sel.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        input.value = clamp((parseInt(input.value, 10) || 1) + 1);
        input.dispatchEvent(new Event('change'));
      });
    });
    input.addEventListener('change', function () { input.value = clamp(input.value); });
  });

  /* ================================================================
     Cart drawer (AJAX cart)
     ================================================================ */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartIcon = document.querySelector('[data-cart-icon]');
  var cartCountEls = document.querySelectorAll('.site-header__cart-count');
  var cartLiveRegion = document.querySelector('[data-cart-live-region]');
  var releaseCartTrap = null;
  var cartOpenedBy = null;

  function announceCart(message) {
    if (cartLiveRegion) cartLiveRegion.textContent = message;
  }

  function openCartDrawer(){
    if (!cartDrawer) return;
    cartOpenedBy = document.activeElement;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden','false');
    releaseCartTrap = trapFocus(cartDrawer.querySelector('.cart-drawer__panel'), cartOpenedBy);
  }
  function closeCartDrawer(){
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden','true');
    if (releaseCartTrap) { releaseCartTrap(); releaseCartTrap = null; }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-close]')) closeCartDrawer();
  });
  if (cartIcon && window.themeSettings && window.themeSettings.cartDrawerEnabled) {
    cartIcon.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  }

  function updateFreeShippingBar(cartTotal){
    var bar = document.querySelector('[data-free-shipping-bar]');
    if (!bar) return;
    var threshold = parseInt(bar.dataset.threshold, 10) || 5000;
    var fill = bar.querySelector('[data-shipping-fill]');
    var msg = bar.querySelector('[data-shipping-message]');
    var pct = Math.min(100, (cartTotal / threshold) * 100);
    if (fill) fill.style.width = pct + '%';
    if (msg) {
      if (cartTotal >= threshold) {
        msg.innerHTML = '🎉 <strong>You\'ve unlocked free shipping!</strong>';
      } else {
        var remaining = ((threshold - cartTotal) / 100).toFixed(2);
        msg.innerHTML = 'You\'re <strong>$' + remaining + '</strong> away from free shipping!';
      }
    }
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderCartDrawer(cart){
    var itemsWrap = document.querySelector('[data-cart-items]');
    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    cartCountEls.forEach(function (el) { el.textContent = cart.item_count; });
    if (subtotalEl) subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
    updateFreeShippingBar(cart.total_price);
    announceCart('Cart updated, ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + ', subtotal $' + (cart.total_price / 100).toFixed(2));

    if (!itemsWrap) return;
    if (cart.item_count === 0) {
      itemsWrap.innerHTML = '<div class="cart-empty" style="padding:60px 20px;"><p>Your cart is empty.</p><button type="button" class="btn btn-primary" style="margin-top:16px;" data-cart-drawer-close>Continue Shopping</button></div>';
      var footer = document.querySelector('.cart-drawer__footer');
      if (footer) footer.style.display = 'none';
      return;
    }
    var footerEl = document.querySelector('.cart-drawer__footer');
    if (footerEl) footerEl.style.display = 'block';

    itemsWrap.innerHTML = cart.items.map(function (item, i) {
      var variantLine = item.variant_title ? '<span>' + escapeHtml(item.variant_title) + '</span>' : '';
      return '<div class="cart-drawer__item" data-cart-line="' + (i + 1) + '">' +
        '<img src="' + (item.image || '') + '&width=160" alt="" width="68" height="68">' +
        '<div class="cart-drawer__item-info"><strong>' + escapeHtml(item.product_title) + '</strong>' + variantLine +
        '<div class="qty-selector qty-selector--sm" data-qty-selector data-line="' + (i + 1) + '">' +
        '<button type="button" data-qty-minus aria-label="Decrease quantity">&minus;</button>' +
        '<input type="number" value="' + item.quantity + '" min="0" data-qty-input aria-label="Quantity for ' + escapeHtml(item.product_title) + '">' +
        '<button type="button" data-qty-plus aria-label="Increase quantity">+</button></div></div>' +
        '<div class="cart-drawer__item-price">$' + (item.final_line_price / 100).toFixed(2) +
        '<button type="button" class="cart-drawer__remove" data-cart-remove data-line="' + (i + 1) + '" aria-label="Remove ' + escapeHtml(item.product_title) + ' from cart">&times;</button></div></div>';
    }).join('');

    bindCartLineEvents();
  }

  function refreshCart(){
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCartDrawer)
      .catch(function(){ showToast('Could not refresh your cart. Please check your connection.', 'error'); });
  }

  function changeLine(line, quantity){
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) {
          showToast(data.description || data.message || 'That quantity is not available.', 'error');
          refreshCart();
          return;
        }
        renderCartDrawer(data);
      })
      .catch(function(){ showToast('Could not update your cart. Please try again.', 'error'); });
  }

  function bindCartLineEvents(){
    document.querySelectorAll('[data-cart-items] [data-qty-selector]').forEach(function (sel) {
      var line = sel.dataset.line;
      var input = sel.querySelector('input');
      var minus = sel.querySelector('[data-qty-minus]');
      var plus = sel.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function () {
        changeLine(line, Math.max(0, parseInt(input.value, 10) - 1));
      });
      if (plus) plus.addEventListener('click', function () {
        changeLine(line, parseInt(input.value, 10) + 1);
      });
      if (input) input.addEventListener('change', function () {
        var n = parseInt(input.value, 10);
        if (isNaN(n) || n < 0) n = 0;
        changeLine(line, n);
      });
    });
    document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () { changeLine(btn.dataset.line, 0); });
    });
  }
  bindCartLineEvents();

  /* Intercept add-to-cart forms for AJAX submission */
  document.querySelectorAll('form[action^="/cart/add"], form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.themeSettings || !window.themeSettings.cartDrawerEnabled) return; // let it submit normally
      e.preventDefault();
      var submitBtn = form.querySelector('button[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }

      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) {
            showToast(result.data.description || result.data.message || 'That item could not be added to your cart.', 'error');
            return;
          }
          refreshCart();
          openCartDrawer();
          showToast('Added to cart', 'success');
        })
        .catch(function(){ showToast('Something went wrong adding this to your cart. Please try again.', 'error'); })
        .finally(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
        });
    });
  });

  /* ================================================================
     Sticky add-to-cart bar (product pages)
     ================================================================ */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var mainAtcForm = document.querySelector('.product-info form[action*="/cart/add"]');
  if (stickyBar && mainAtcForm) {
    var observerTarget = document.querySelector('.qty-add-row');
    if (observerTarget && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting && window.scrollY > 300);
        });
      }, { threshold: 0 });
      io.observe(observerTarget);
    }
    var stickyBtn = stickyBar.querySelector('button[type="submit"], button[data-sticky-submit]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        mainAtcForm.querySelector('button[type="submit"]').click();
      });
    }
  }

  /* ================================================================
     Exit intent popup
     ================================================================ */
  var exitPopup = document.querySelector('[data-exit-popup]');
  var releaseExitTrap = null;
  if (exitPopup) {
    function closeExitPopup(persistDismissal) {
      exitPopup.classList.remove('is-open');
      if (releaseExitTrap) { releaseExitTrap(); releaseExitTrap = null; }
      if (persistDismissal) {
        try { localStorage.setItem('exitPopupDismissed', '1'); } catch (err) {}
      }
    }
    var alreadyDismissed = false;
    try { alreadyDismissed = !!localStorage.getItem('exitPopupDismissed'); } catch (err) {}

    if (!alreadyDismissed) {
      var exitShown = false;
      document.addEventListener('mouseout', function (e) {
        if (exitShown) return;
        if (e.clientY <= 0 && e.relatedTarget === null) {
          exitPopup.classList.add('is-open');
          releaseExitTrap = trapFocus(exitPopup.querySelector('.exit-popup__card'), document.activeElement);
          exitShown = true;
        }
      });
    }
    exitPopup.querySelectorAll('[data-exit-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeExitPopup(true);
      });
    });
  }

  /* Shared Escape-key handling for any open overlay */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (searchPanel && searchPanel.classList.contains('is-open')) { closeSearch(); return; }
    if (cartDrawer && cartDrawer.classList.contains('is-open')) { closeCartDrawer(); return; }
    if (exitPopup && exitPopup.classList.contains('is-open')) {
      exitPopup.classList.remove('is-open');
      if (releaseExitTrap) { releaseExitTrap(); releaseExitTrap = null; }
    }
  });

  /* ================================================================
     Announcement countdown
     ================================================================ */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date(el.dataset.countdown).getTime();
    if (isNaN(end)) return;
    var timerId;
    function tick(){
      var diff = end - Date.now();
      if (diff <= 0) { el.textContent = 'Sale ended'; clearTimeout(timerId); return; }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.innerHTML = '<span>' + String(h).padStart(2,'0') + 'h</span> <span>' + String(m).padStart(2,'0') + 'm</span> <span>' + String(s).padStart(2,'0') + 's</span>';
      timerId = setTimeout(tick, 1000);
    }
    tick();
  });

  /* ================================================================
     Variant picker: sync selection + availability
     ================================================================ */
  document.querySelectorAll('[data-gallery]').length; // no-op (keeps section ordering readable)

  document.querySelectorAll('.product-main').forEach(function (root) {
    var variantScript = root.querySelector('[data-variant-json]');
    if (!variantScript) return;
    var variants;
    try { variants = JSON.parse(variantScript.textContent); } catch (err) { return; }

    var form = root.querySelector('form[action^="/cart/add"], form[action*="/cart/add"]');
    var idSelect = form ? form.querySelector('select[name="id"]') : null;
    var priceEl = root.querySelector('.product-info__price .price');
    var submitBtn = form ? form.querySelector('button[type="submit"]') : null;
    var stickyBtnEl = root.parentElement ? root.parentElement.querySelector('[data-sticky-atc] button') : document.querySelector('[data-sticky-atc] button');

    function currentOptions(){
      var opts = [];
      root.querySelectorAll('.variant-picker').forEach(function (picker, i) {
        var checked = picker.querySelector('input[type=radio]:checked');
        opts[i] = checked ? checked.value : null;
      });
      return opts;
    }

    function setAvailability(match) {
      var available = match ? match.available : false;
      if (submitBtn) {
        submitBtn.disabled = !available;
        submitBtn.textContent = !match ? 'Unavailable' : (available ? 'Add to Cart' : 'Sold Out');
      }
      if (stickyBtnEl) {
        stickyBtnEl.disabled = !available;
        stickyBtnEl.textContent = !match ? 'Unavailable' : (available ? 'Add to Cart' : 'Sold Out');
      }
    }

    function updateVariant(){
      var opts = currentOptions();
      var match = variants.find(function (v) {
        var vOpts = [v.option1, v.option2, v.option3].filter(function (x) { return x !== null; });
        return vOpts.every(function (val, i) { return val === opts[i]; });
      });
      if (match) {
        if (idSelect) idSelect.value = match.id;
        if (priceEl) priceEl.textContent = '$' + (match.price / 100).toFixed(2);
      }
      setAvailability(match);
    }

    root.querySelectorAll('.variant-picker input[type=radio]').forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });
  });

  /* ================================================================
     Collection filters (native Shopify filtering: auto-submit on change)
     ================================================================ */
  var filterForm = document.querySelector('[data-filter-form]');
  if (filterForm) {
    filterForm.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () { filterForm.submit(); });
    });
    var priceInputs = filterForm.querySelectorAll('[data-price-min], [data-price-max]');
    var priceDisplay = filterForm.querySelector('[data-price-display]');
    priceInputs.forEach(function (input) {
      input.addEventListener('input', function () {
        if (!priceDisplay) return;
        var min = filterForm.querySelector('[data-price-min]');
        var max = filterForm.querySelector('[data-price-max]');
        priceDisplay.textContent = '$' + (min ? min.value : 0) + ' – $' + (max ? max.value : '');
      });
      input.addEventListener('change', function () { filterForm.submit(); });
    });
    var clearBtn = filterForm.querySelector('[data-filter-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.href = clearBtn.getAttribute('href');
      });
    }
  }

});
